import { Component, OnInit,ViewChild } from '@angular/core';
import { FileUpload } from 'primeng/fileupload';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { ConfirmationService } from 'primeng/api';
import { NotificationTypes } from 'src/app/app.enums';
import { Admins } from 'src/app/models/admin.model';
import { AdminService } from 'src/app/Services/admin.service';
import { AuthConfig, AuthService } from 'src/app/Services/auth.service';
import { CloudinaryImageService } from 'src/app/Services/cloudinary-image.service';
import { NotificationsService } from 'src/app/Services/shared/notifications.service';
import { ImageCroppedResponse } from 'src/app/common/image-cropper/image-cropper.component';
import { TranslocoService } from '@jsverse/transloco';

@Component({
    selector: 'app-admins',
    templateUrl: './admins.component.html',
    styleUrls: ['./admins.component.css'],
    standalone: false
})
export class AdminsComponent implements OnInit{
  @ViewChild('fileUpload') fileUpload!: FileUpload;
  @ViewChild('buissnesslogo') buissnesslogo!: FileUpload;
  public admins: Admins[] = [];
  public adminFormData: Admins = {} as Admins;
  public isEditMode: boolean = false;
  public isadminDialogvisible: boolean = false;
  public showCropperDialog: boolean = false;
  public selectedTabIndex: number = 0;
  public selectedFile: File | null = null;
  public currentSelectedImageToCrop?: File | null;
  public authConfig: AuthConfig = {};
  public adminsLoading: boolean = true;
  public imgType: string = '';

  constructor(private router:Router,
    private uploadService: CloudinaryImageService,
    private adminsService: AdminService,
    private authService: AuthService,
    private confirmationService: ConfirmationService,
    private ngxSpinnerService: NgxSpinnerService,
    private notificationsService: NotificationsService,
    private transloco: TranslocoService,){

  }

  ngOnInit(): void {
    this.authConfig = this.authService.getAuthConfig();
    if (this.authConfig.IsSuperAdmin || this.authConfig.IsAdministrator) {
      this.getAllAdmins();
    }
    this.selectedTabIndex = 0;
  }

  public getAllAdmins(){
    this.ngxSpinnerService.show();
    this.adminsLoading = true;
    this.adminsService.getAllAdmins().subscribe((admins: Admins[]) => {
        console.log(admins)
        this.admins = admins;
        console.log('admins', this.admins);
        this.adminsLoading = false;
        this.ngxSpinnerService.hide();
      },(error) => {console.error(error);this.adminsLoading = false;this.ngxSpinnerService.hide();}
    );
  }

  public onShowAdminDailog(){
    this.isadminDialogvisible = true
    this.selectedTabIndex = 0
  }

  public oncloseAdminDialog(){
    this.isadminDialogvisible = false
    this.adminFormData = {} as Admins;
    this.isEditMode = false
    this.selectedTabIndex = 0
  }

  public onEditAdmin(Id:string){
    const admin = this.admins.find((admin)=>admin.Id === Id)
    console.log(admin)
    if(admin){
       this.adminFormData = {...admin}
       this.isEditMode = true
       this.isadminDialogvisible = true
    }
  }

  public onSaveAdmin(){
    if(!this.isEditMode){
      this.ngxSpinnerService.show();
      this.adminFormData.ImgUrl = this.adminFormData.ImgUrl;
      console.log('this.admins', this.adminFormData);
      this.adminsService.saveAdmin(this.adminFormData).subscribe(
        (response) => {
          this.ngxSpinnerService.hide();
          if (response.Success) {
            this.oncloseAdminDialog();
            this.notificationsService.showNotification(this.transloco.translate('admins.success'),response.ResponseMessage,NotificationTypes.Success);
            this.getAllAdmins();
          //   this.artistDialogvisible = false;
          //   this.selectedTabIndex = 0;
          } else {
            this.notificationsService.showNotification(this.transloco.translate('admins.error'),response.ResponseMessage,NotificationTypes.Error);
          }
        },(error) => {console.error(error);this.ngxSpinnerService.hide();}
      );
    }else{
      this.ngxSpinnerService.show();
      this.adminFormData.ImgUrl = this.adminFormData.ImgUrl;
      console.log('this.admins', this.adminFormData);
      this.adminsService.saveAdmin(this.adminFormData).subscribe(
        (response) => {
          this.ngxSpinnerService.hide();
          if (response.Success) {
            this.oncloseAdminDialog();
            this.notificationsService.showNotification(this.transloco.translate('admins.success'),response.ResponseMessage,NotificationTypes.Success);
            this.getAllAdmins();
          //   this.artistDialogvisible = false;
            this.selectedTabIndex = 0;
          } else {
            this.notificationsService.showNotification(this.transloco.translate('admins.error'),response.ResponseMessage,NotificationTypes.Error);
          }
        },(error) => {console.error(error);this.ngxSpinnerService.hide();}
      );
    }
  }

  // public onFileSelected(files: File[], imgType: string) {
  //   console.log(files);
  //   this.selectedFile = files[0];
  //   if (this.selectedFile) {
  //     const formData = new FormData();
  //     formData.append('ImageFile', this.selectedFile);
  //     if (imgType == 'ImgUrl') {
  //       this.uploadService.uploadImage(formData).subscribe((res: any) => {
  //         this.adminFormData.ImgUrl = res;
  //       });
  //     } else if (imgType == 'BusinessLogoUrl') {
  //       this.uploadService.uploadImage(formData).subscribe((res: any) => {
  //         this.adminFormData.BusinessLogoUrl = res;
  //       });
  //     }
  //   } else {
  //     console.log('No file selected.');
  //   }
  // }

  public onFileSelected(files: File[], imgType: string) {
    console.log(files);
    if(files.length > 0){
      this.selectedFile = files[0]; // Get the selected file
      console.log(this.selectedFile);
  
      // Check if the selected file is an image
      const isImage = this.selectedFile && this.selectedFile.type.includes('image');
      if (isImage) {
          this.imgType = imgType; // Store the image type (ArtistImg or BusinessLogo)
          this.showCropperDialog = true; // Show cropper dialog
          this.currentSelectedImageToCrop = this.selectedFile; // Set the image to crop
      } else {
          console.log('Selected file is not an image');
      }
    }
  }
  
  // Cropped Image Handler
  public onImageCropped(croppedImage: ImageCroppedResponse) {
    console.log(croppedImage);
    // Set the cropped image as the selected file
    this.selectedFile = croppedImage.CroppedImage;
  
    // Now upload the cropped image
    this.uploadImage(this.imgType);
    
    // Close the cropper dialog
    this.showCropperDialog = false;
  }
  
  // Image Upload Logic
  public uploadImage(value: string) {
    if (this.selectedFile) {
        const formData = new FormData();
        formData.append('ImageFile', this.selectedFile);
        // Upload the cropped image based on the value (ArtistImg or BusinessLogo)
        if (value == 'AdminImgUrl') {
            this.uploadService.uploadImage(formData).subscribe((res: any) => {
                this.adminFormData.ImgUrl = res;
            });
        } else if (value == 'BusinessLogoUrl') {
            this.uploadService.uploadImage(formData).subscribe((res: any) => {
                this.adminFormData.BusinessLogoUrl = res;
            });
        }
    } else {
        console.log('No image to upload.');
    }
  }

  public removeImg(value: string) {
    if (value == 'ImgUrl') {
      this.adminFormData.ImgUrl = null!;
    } else if (value == 'BusinessLogoUrl') {
      this.adminFormData.BusinessLogoUrl = null!;
    }
  }

  public onImageCropperClose($event: any) {
    console.log('Dialog close event:', $event);
    if ($event.skipCropping == true) {
      this.selectedFile = null;
      this.currentSelectedImageToCrop = null;
      this.showCropperDialog = false;
      console.log('this.selectedFile', this.selectedFile);
      console.log('this.currentSelectedImageToCrop', this.currentSelectedImageToCrop);
      if(this.fileUpload){
        this.fileUpload.clear();
      }
      if(this.buissnesslogo){
        this.buissnesslogo.clear();
      }
        // Handle skipping cropping if needed
    }
  }

  public onDeleteAdmin(Id: string) {
    const admin = this.admins.find((admin)=>admin.Id === Id)
    this.confirmationService.confirm({
      message: this.transloco.translate('admins.confirmDelete', { name: admin?.Name }),
      accept: () => {
        this.ngxSpinnerService.show();
        this.adminsService.deleteAdmin(Id).subscribe((response) => {
            this.ngxSpinnerService.hide();
            if (response.Success) {
              this.notificationsService.showNotification(this.transloco.translate('admins.success'),response.ResponseMessage,NotificationTypes.Success);
              var index = this.admins.findIndex((admin) => admin.Id == Id);
              if (index >= 0) {
                this.admins.splice(index, 1);
              }
            } else {
              this.notificationsService.showNotification(this.transloco.translate('admins.error'),response.ResponseMessage,NotificationTypes.Error);
            }
          },
          (error) => {console.error(error);this.ngxSpinnerService.hide();}
        );
      },
    });
  }

  public switchAccount(rowData:Admins): void {
    console.log(rowData)
    this.ngxSpinnerService.show();
    this.authService.switchAccount(rowData.Id || '').subscribe(
      (response) => {
        console.log(response)
        this.ngxSpinnerService.hide();
        if (response.Success) {
          this.router.navigate(['/dashboard']).then(() => {
            location.reload();
          });
          return;
        }
        this.notificationsService.showNotification(this.transloco.translate('admins.error'), response.ResponseMessage, NotificationTypes.Error);
      },
      (error) => {
        console.error(error);
        this.ngxSpinnerService.hide();
      }
    );
  }
}
